import { render, staticRenderFns } from "./AddStone.vue?vue&type=template&id=0930c0d0&"
import script from "./AddStone.vue?vue&type=script&lang=js&"
export * from "./AddStone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports